import React from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import { handleChange } from "presentation/utils/functions/generic";

import RemoveAction from "presentation/components/remove-action";
import AddButton from "presentation/components/buttons/add";

import {
    changeStagesList,
    handleChangeStages,
    stagesFormValue,
    mountStageItems
} from 'presentation/pages/evaluation-schemes/functions/stages';

class GeneralTabEvaluationSchemeForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            componentFlags: []
        };
    }

    addOption = () => {
        let { component } = this.props;
        let { totalStageItems } = component.state;
        component.setState({ ...component.state, totalStageItems: totalStageItems + 1 }, () => mountStageItems(component));
    }

    removeAction = (key) => {
        let { component } = this.props;

        let { totalStageItems } = component.state;

        let data = changeStagesList(component, { key: key }, true);

        //reorganiza as keys
        let index = 0;
        data.map((element, i) => {
            if (!element.isDeleteRequested) {
                element.key = index + 1;
                index++;
            }
            return element;
        });

        component.setState({ ...component.state, totalStageItems: totalStageItems - 1, stages: data }, () => mountStageItems(component));
    }


    render() {

        const { evaluationSchemeForm, stages, loading, totalStageItems, component } = this.props;

        const { addOption, removeAction } = this;

        const validStages = stages.filter(x => !(x.isDeleteRequested && x.isDeleteRequested == true));
        const deleteIsDisabled = totalStageItems < 2;
        return (
            <Container>
                <Row>
                    <Col>
                        <h4>Informações do regime de avaliação</h4>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="name">Nome</Form.Label>
                            <Form.Control
                                type="text"
                                id="name"
                                name="name"
                                defaultValue={evaluationSchemeForm.name}
                                onChange={(e) => handleChange(e, component, 'evaluationSchemeForm')}
                                aria-describedby="nameHelpBlock"
                            />
                            <Form.Text id="nameHelpBlock" muted>
                                Informe o nome do regime de avaliação
                            </Form.Text>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <hr />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h4>Etapas</h4>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <table className="table table-borderless">
                            <thead>
                                <tr>
                                    <th width="10%">Etapa principal</th>
                                    <th width="50%">Nome da etapa</th>
                                    <th className="text-end" width="40%"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {validStages.map((element, index) => {
                                    let key = element.key;

                                    let isMainStage = stagesFormValue(key, 'isMainStage', component);
                                    let stageName = stagesFormValue(key, 'name', component);

                                    return (
                                        <tr key={`stage-${key}`}>
                                            <td>
                                                <Form.Check
                                                    type="switch"
                                                    checked={isMainStage || false}
                                                    label={(isMainStage || false) == true ? "Sim" : "Não"}
                                                    id={`isMainStage-${key}`}
                                                    name={`isMainStage-${key}`}
                                                    data-field-name="isMainStage"
                                                    data-field-is-true-unique="true"
                                                    onChange={(event) => handleChangeStages(key, event, component)}
                                                />
                                            </td>
                                            <td>
                                                <Form.Control
                                                    type="text"
                                                    id={`name-${key}`}
                                                    name={`name-${key}`}
                                                    data-field-name="name"
                                                    defaultValue={stageName || ""}
                                                    onChange={(event) => handleChangeStages(key, event, component)}
                                                />
                                            </td>
                                            <td>
                                                <RemoveAction
                                                    className="float-end"
                                                    component={this}
                                                    optionKey={key}
                                                    loading={loading}
                                                    deleteIsDisabled={deleteIsDisabled}
                                                    removeConfirmationText={"Tem certeza?"}
                                                    removeAction={removeAction} />
                                            </td>
                                        </tr>
                                    );
                                })}
                                <tr>
                                    <td colSpan={3}>
                                        <div className="text-end">
                                            <AddButton
                                                containerProps={{
                                                    onClick: addOption,
                                                    variant: 'success',
                                                    className: 'mt-1 mb-1'

                                                }}
                                                title='Adicionar etapa'
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Col>
                </Row>
            </Container>
        );
    };
}

export default GeneralTabEvaluationSchemeForm;